var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("span", [_vm._v("Единицы отступа")]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  items: _vm.$options.size,
                  "item-text": "title",
                  "item-value": "value",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.size,
                },
                on: {
                  change: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "size")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }